import React, { useState } from "react";
import { SlGraduation } from "react-icons/sl";
import { IoBriefcaseOutline } from "react-icons/io5";
import EducationList from "./Qualification/EducationList";
import ExperienceList from "./Qualification/ExperienceList";

function Qualification() {
  const [loading, setLoading] = useState(true);
  const [choose, setChoose] = useState("Education");
  return (
    <div id="qualification">
      <div className="text-center mb-[50px]">
        <h1 className=" text-3xl lg:text-4xl font-semibold">Qualification</h1>
        <p className="lg:text-xl">My personal journey</p>
      </div>

      <div className="lg:w-7/12 mx-auto">
        <div
          className="w-10/12 flex justify-between mx-auto
        sm:justify-center sm:gap-10  text-[1.1rem] font-semibold lg:justify-center lg:gap-10
        xs:justify-around  xs:w-full
        "
        >
          <button
            className={`${
              choose === "Education" ? "bg-black text-white" : ""
            } flex py-[10px] px-[20px] items-center gap-2 rounded-md`}
            onClick={() => {
              setLoading(true);
              setChoose("Education");
            }}
          >
            <SlGraduation fontSize={"1.8rem"} />
            Education
          </button>
          <button
            onClick={() => {
              setLoading(false);
              setChoose("Experience");
            }}
            className={`${
              choose === "Experience" ? "bg-black text-white" : ""
            } flex items-center gap-2 py-[10px] px-[20px]  rounded-md`}
          >
            <IoBriefcaseOutline fontSize={"1.8rem"} />
            Experience
          </button>
        </div>
        {loading ? <EducationList /> : <ExperienceList />}
      </div>
    </div>
  );
}

export default Qualification;
